/**
 * Teclado.ts — Atalhos.
 *   M      centralizar meu planeta
 *   ESC    fechar dialogo / cancelar selecao
 *   A      selecionar todos os meus planetas (Fase 6)
 *   1..4   percentual do envio rapido: 25/50/75/100% (Fase 6)
 *   Enter  confirma o dialogo aberto (Fase 6)
 */

import type { EstadoJogo } from '../domain/tipos';
import type { Camera } from '../render/Camera';
import type { Selecao } from './Selecao';
import type { DialogFrota } from '../ui/DialogFrota';

const PCT_POR_TECLA: Record<string, number> = { '1': 0.25, '2': 0.5, '3': 0.75, '4': 1 };

export class Teclado {
  constructor(
    private readonly estado: EstadoJogo,
    private readonly camera: Camera,
    private readonly selecao: Selecao,
    private readonly dialog: DialogFrota,
    private readonly aoMudarPct: () => void,
  ) {}

  iniciar(): void {
    window.addEventListener('keydown', (e) => this.onKeyDown(e));
  }

  private onKeyDown(e: KeyboardEvent): void {
    const alvo = e.target as HTMLElement | null;
    if (alvo && (alvo.tagName === 'INPUT' || alvo.tagName === 'TEXTAREA')) {
      if (e.key === 'Enter' && this.dialog.visivel()) { e.preventDefault(); this.dialog.enviar(); }
      return;
    }
    if (e.key === 'm' || e.key === 'M') {
      this.centralizarMeuPlaneta();
    } else if (e.key === 'Escape') {
      if (this.dialog.visivel()) this.dialog.fechar();
      else this.selecao.cancelar();
    } else if (e.key === 'a' || e.key === 'A') {
      if (!e.metaKey && !e.ctrlKey) this.selecao.selecionarTodos();
    } else if (e.key === 'Enter') {
      if (this.dialog.visivel()) { e.preventDefault(); this.dialog.enviar(); }
    } else if (PCT_POR_TECLA[e.key] !== undefined) {
      this.estado.pctEnvio = PCT_POR_TECLA[e.key];
      this.aoMudarPct();
    }
  }

  private centralizarMeuPlaneta(): void {
    for (const p of this.estado.planetas.values()) {
      if (p.donoId === this.estado.suaCor) {
        this.camera.setAlvo(p.x, p.y, 1.0);
        return;
      }
    }
  }
}
